import { apiGateway } from "@/_old/services/api-gateway";
import {
  CreateNotificationSchedulePayload,
  ListNotificationSchedulesParams,
  ListNotificationSchedulesResponse,
  NotificationSchedule,
  UpdateNotificationSchedulePayload,
} from "../types";

/**
 * `notification-schedules` do woba-backend. `company_id`/`user_id` são sempre
 * derivados do JWT pelo controller — nunca enviados em body/query (e seriam
 * descartados pelo ValidationPipe com `whitelist: true`).
 */
const BASE_PATH = "/notification-schedules";

export async function getReportSchedules(
  params: ListNotificationSchedulesParams = {},
  signal?: AbortSignal,
): Promise<NotificationSchedule[]> {
  const { data } = await apiGateway.get<ListNotificationSchedulesResponse>(
    BASE_PATH,
    { params, signal },
  );
  return data.data ?? [];
}

export async function createReportSchedule(
  payload: CreateNotificationSchedulePayload,
): Promise<NotificationSchedule> {
  const { data } = await apiGateway.post<NotificationSchedule>(
    BASE_PATH,
    payload,
  );
  return data;
}

export async function updateReportSchedule(
  id: number,
  payload: UpdateNotificationSchedulePayload,
): Promise<NotificationSchedule> {
  const { data } = await apiGateway.patch<NotificationSchedule>(
    `${BASE_PATH}/${id}`,
    payload,
  );
  return data;
}

/** DELETE responde 204 sem body. */
export async function deleteReportSchedule(id: number): Promise<void> {
  await apiGateway.delete(`${BASE_PATH}/${id}`);
}

export async function pauseReportSchedule(
  id: number,
): Promise<NotificationSchedule> {
  const { data } = await apiGateway.post<NotificationSchedule>(
    `${BASE_PATH}/${id}/pause`,
  );
  return data;
}

export async function resumeReportSchedule(
  id: number,
): Promise<NotificationSchedule> {
  const { data } = await apiGateway.post<NotificationSchedule>(
    `${BASE_PATH}/${id}/resume`,
  );
  return data;
}
